import {IShortAbility, IAbilities} from 'Dictionaries/models/IAbilities';
import {AbilityType} from 'Common/constants/AbilityType';

export function getAbilitiesByType<T = IShortAbility | IAbilities>(abilities: Array<T>, type: AbilityType) {
  return abilities.filter(x => x['type'] === type);
}
